import classNames from 'classnames'
import { companyValueSelector } from 'wordpress/selectors'
import { companyAddressSelector, companySelector } from 'settings/selectors'

import styles from '../styles/footer.module.scss'

const $InfoStrip = ({ companyValue, company, companyAddress }) => (
    <>
        {companyValue ? <p>{companyValue}</p> : <p>{`${company}  ${new Date().getFullYear()}`}</p>}
        <p>
            <T>copyright.text</T>
        </p>
        <p>{companyAddress}</p>
    </>
)

const mapStateToProps = createStructuredSelector({
    companyValue: companyValueSelector,
    company: companySelector,
    companyAddress: companyAddressSelector,
})

export const InfoStrip = connect(mapStateToProps)($InfoStrip)

export default function FooterInfoStrip() {
    return (
        <div className={classNames('container-fluid', styles.footerStripContainer, 'text-small')}>
            <InfoStrip />
        </div>
    )
}
